import { Button } from '@common/components';
import SectionContainer from '@common/components/SectionContainer';
import { token } from 'odyssey';
import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

const SLIDER_ITEM_WIDTH = 330;

export const FeaturedEntityFullWidthWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  margin: 20px 0;
`;

export const FeaturedEntityContainer = styled(SectionContainer)`
  display: flex;
  max-width: 1440px;
  margin: 0px auto;
  padding: 0px 0px 0px 20px;
  flex-direction: column;

  ${media.md`
    flex-direction: row;
  `}
`;

export const Title = styled.h2`
  margin-top: 0;
  font-size: ${token('font-size-2xl')};
  color: ${token('color-section-title')};
`;

export const Description = styled.div`
  display: none;

  ${media.md`
    display: flex;
  `}
`;

export const DetailsColumn = styled.div<{ expanded?: boolean }>`
  display: flex;
  margin-right: 10px;
  flex-direction: column;
  flex-basis: 45%;
  align-items: flex-start;
  justify-content: center;
  min-width: 360px;
  max-width: ${(props) => (props.expanded ? 'none' : '360px')};
  padding: ${token('space-8')} 0;
`;

export const SliderWrapper = styled.section<{ quantity: number }>`
  width: ${({ quantity }) => quantity * 150}px;
  ${media.md`
    width: ${({ quantity }: any) => quantity * SLIDER_ITEM_WIDTH}px;
  `}

  max-width: 100%;
  margin: 12px auto 0px auto;

  .slick-initialized .slick-track {
    display: flex;

    .slick-slide {
      display: flex;
      height: inherit !important;
      align-items: stretch;
      justify-content: stretch;
    }
  }
`;

export const ShowAllEntitiesButton = styled(Button)`
  margin-top: 35px;
`;
export const ShowAllButtonDesktopWrapper = styled.div`
  display: none;

  ${media.md`
    display: flex;
  `}
`;
export const ShowAllButtonMobileWrapper = styled.div`
  margin-top: -15px;
  display: flex;

  ${media.md`
    display: none;
  `}
`;
